export default "__VITE_ASSET__BuN4zLv___"